import LocalImages from "../../../../../../../assets/images/local-images";
import ChecklistItemStatus from "../../../../../../../models/checklist/checklist-item/checklist-item-status";

export const getStatusIcon = (
  status: ChecklistItemStatus,
  isInfo: boolean
): string => {
  const images = LocalImages.shared.images;

  if (isInfo && status !== ChecklistItemStatus.Resolved) {
    return images.icons.card.info;
  }

  switch (status) {
    case ChecklistItemStatus.Resolved:
      return images.icons.card.resolved;
    case ChecklistItemStatus.NotYetResolved:
      return images.icons.card.actionRequired;
    case ChecklistItemStatus.VerificationRequired:
      return images.icons.card.hasIssues;
    default:
      return images.icons.card.actionRequired;
  }
};
